const typography = {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    sizes: {
        xs: '11px',
        sm: '12px',
        md: '14px',
        lg: '16px',
        xl: '22px',
        xxl: '32px',
        amount: '52px',
    },
    weights: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
    }
};

const shadows = {
    sm: '0 1px 3px rgba(0,0,0,0.05)',
    md: '0 4px 12px rgba(0,0,0,0.05)',
    lg: '0 10px 20px rgba(0,0,0,0.2)',
    selected: '0 4px 14px rgba(0,0,0,0.1)',
    hover: '0 6px 16px rgba(0,0,0,0.1)',
};

const borders = {
    radius: {
        sm: '8px',
        md: '10px',
        lg: '12px',
        xl: '14px',
        xxl: '20px',
        full: '50%',
    }
};

export const lightTheme = {
    colors: {
        primary: {
            main: '#1f2937',     // Dark grayish blue used for primary elements/buttons
            light: '#374151',    // Lighter gray for hover states
            dark: '#111827',     // Darker shade
        },
        secondary: {
            main: '#059669',     // Emerald/Green for active/success states
            light: '#10b981',    // Light emerald for balances
            bg: '#f0fdf4',       // Very light green background
            border: '#bbf7d0',   // Green border
        },
        danger: {
            main: '#ef4444',     // Red for errors/insufficient funds
            light: '#f87171',
            bg: '#fef2f2',
        },
        blue: {
            main: '#2563eb',     // Blue for Domestic Wire
            light: '#3b82f6',    // Lighter blue for SEPA
        },
        purple: {
            main: '#7c3aed',     // Purple for SWIFT
        },
        red: {
            main: '#dc2626',     // RTP red
        },
        background: {
            main: '#f0f2f5',     // General app background
            paper: '#ffffff',    // White background for cards/modals
            selected: '#f3f4f6', // Slightly darker background for selected states
            deactivated: '#fafafa', // Light grey for disabled states
            overlay: 'rgba(0, 0, 0, 0.5)', // Modal overlay
            tab: '#f3f4f6',      // Tab container background
        },
        text: {
            primary: '#1f2937',  // Main text (Blackish)
            secondary: '#6b7280',// Grey text for labels/subtitles
            disabled: '#9ca3af', // Light grey text for disabled elements
            contrast: '#ffffff', // White text on dark buttons
            dark: '#000000',     // Pitch black
        },
        border: {
            main: '#e5e7eb',     // Standard border color
            hover: '#d1d5db',    // Border shadow/hover
            inputFocus: '#000000', // Border focus color
        }
    },
    typography,
    shadows,
    borders,
    isDark: false
};

export const darkTheme = {
    colors: {
        primary: {
            main: '#f3f4f6',     // Light color for primary elements/buttons in dark mode
            light: '#e5e7eb',
            dark: '#ffffff',
        },
        secondary: {
            main: '#10b981',     // Slightly brighter green for dark mode contrast
            light: '#34d399',
            bg: 'rgba(16, 185, 129, 0.15)', // Transparent green bg
            border: '#059669',
        },
        danger: {
            main: '#f87171',
            light: '#fca5a5',
            bg: 'rgba(239, 68, 68, 0.15)',
        },
        blue: {
            main: '#60a5fa',
            light: '#93c5fd',
        },
        purple: {
            main: '#a78bfa',
        },
        red: {
            main: '#f87171',
        },
        background: {
            main: '#111827',     // Very dark blue/gray for app background
            paper: '#1f2937',    // Slightly lighter for cards/modals
            selected: '#374151',
            deactivated: '#1f2937',
            overlay: 'rgba(0, 0, 0, 0.7)',
            tab: '#374151',
        },
        text: {
            primary: '#f9fafb',  // Off-white for main text 
            secondary: '#9ca3af',// Light gray for subtitles
            disabled: '#6b7280',
            contrast: '#111827', // Dark text on light buttons
            dark: '#ffffff',
        },
        border: {
            main: '#374151',     // Dark borders
            hover: '#4b5563',
            inputFocus: '#f3f4f6',
        }
    },
    typography,
    shadows: {
        sm: '0 1px 3px rgba(0,0,0,0.3)',
        md: '0 4px 12px rgba(0,0,0,0.4)',
        lg: '0 10px 20px rgba(0,0,0,0.5)',
        selected: '0 4px 14px rgba(0,0,0,0.3)',
        hover: '0 6px 16px rgba(0,0,0,0.4)',
    },
    borders,
    isDark: true
};

// Aliasing for backwards compatibility in case anywhere was directly importing `theme`
export const theme = lightTheme;
